/**
 * This component encapsulates the search functionality for notes
 *
 * */
import {mapState, mapMutations} from 'vuex'
import notesMutations from '#/notes/store/mutationTypes'

export default {
  name: 'NotesSearch',
  computed: {
    ...mapState('notes', [
      'currentSearch'
    ]),
    searchQuery: {
      get () {
        return this.currentSearch
      },
      set (search) {
        this.setCurrentSearch(search)
      }
    }
  },
  methods: {
    ...mapMutations({
      setCurrentSearch: notesMutations.SET_SEARCH,
      updatePagination: notesMutations.UPDATE_PAGINATION
    }),
    submitSearch (search) {
      this.searchQuery = search
      this.resetPaginationPage()
      this.$emit('search-updated')
    },
    resetPaginationPage () {
      this.updatePagination({
        currentPage: 1
      })
    }
  },
  render () {
    return this.$scopedSlots.default({
      searchQuery: this.searchQuery,
      submitSearch: this.submitSearch
    })
  }
}
